/* eslint-disable */
import React from "react";
import {Helmet} from "react-helmet";
import GuideList from "../partials/GuideList";
import ListLayout from "./ListLayout";
import ArtistFill from "../partials/ArtistFill";
// import { articles as concerts_filtered } from "../../db/news";
import "../styles/ConcertList.css";
import "../styles/FestivalList.css";
import {
  Link,
} from "react-router-dom";


class GuideLayout extends React.Component {
  //state = [];
  render() {
    return (
      <>
      {this.state && this.state.articles?(
      <>
      <div className="main-container concerts-container">
        <Helmet>
          <title>Exclaim! Guides</title>
          <meta name="twitter:title" content="Canadian Festivals | Festival Guide by Exclaim!" />
          <meta property="og:title" content="Canadian Festivals | Festival Guide by Exclaim!" />
          <link rel="canonical" href="https://exclaim.ca/festivals" />
          <meta property="og:url" content="https://exclaim.ca/festivals" />
          <meta name="keywords" content="festivals, music festivals, canada, canadian, concerts, listings" />

          <meta name="description" content="Festival listings and coverage from all across Canada." />
          <meta property="og:description" content="Festival listings and coverage from all across Canada." />
          <meta name="twitter:description" content="Festival listings and coverage from all across Canada." />

          <meta property="og:image" content="http://exclaim.ca/assets/images/ex_concerts.png" />
          <meta property="og:image:secure_url" content="https://exclaim.ca/assets/images/ex_concerts.png" />
          <meta name="twitter:image" content="https://exclaim.ca/assets/images/ex_concerts.png" />
          <meta property="og:image:width" content="150" />
          <meta property="og:image:height" content="150" />
        </Helmet>



        <GuideList title={"Exclaim! Specialty Guides"} articles={this.state["articles"]} />
      </div>
      <ListLayout section="all" filter="new-faves" limit="7"/>
      </>
    ):(<></>)}
      </>
    )
  }

  handleArtistSubmit(e){
    e.preventDefault();
    console.log("ARTIST SUBMIT");
    var path = '/festivals/artist?artist='+encodeURIComponent(document.getElementById('artist-fill-festivals').value);
    this.props.navigate(path);
  }


  cityToggle(){
    console.log("CITY");
    var region = document.getElementById('region-selector');
    var artist = document.getElementById('fest-artist-selector');
    if(!artist.classList.contains('hide')){
        artist.classList.toggle('hide');
        //artist.style['pointer-events'] = 'none';
    }
    if(!region.classList.contains('hide')){
      //region.style['pointer-events'] = 'all';
    }
    region.classList.toggle('hide');
  }

  artistToggle(){
    console.log("ARTIST");
    var artist = document.getElementById('fest-artist-selector');
    var region = document.getElementById('region-selector');

    if(!region.classList.contains('hide')){
        region.classList.toggle('hide');
        //region.style['pointer-events'] = 'none';
    }
    if(!artist.classList.contains('hide')){
    //  artist.style['pointer-events'] = 'all';
    }
    artist.classList.toggle('hide');


  }

  constructor(props){
    super(props);
    // if(!this.props.slug) return;

    var h = new global.Headers({
     // "Authorization": "Token f439775cde934231771bc0d55b467dd6",
     "Content-Type": "application/json"
   });
   // var url = "https://media-pidgin.herokuapp.com/articles/"+this.props.slug;

   var url = "/epi/article/filtered?limit=3";
      fetch(url,{
      method: "get",
      headers: h})
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState(result);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  componentDidMount() {

  }
}
export default GuideLayout
